<div
  class="bg-surface-300 flex w-max flex-col items-center rounded-xl p-1 select-none"
  [class]="{
    'shadow-lg': showShadow(),
  }"
>
  <div class="font-family-din p-1 text-sm font-medium tracking-wide text-black uppercase">{{ label() }}</div>
  <div
    class="bg-card-background text-text-primary font-family-din min-w-3xs rounded-br-lg rounded-bl-lg px-15 py-3 text-center text-4xl font-medium"
  >
    {{ mainText() }}
  </div>
</div>
